// extracted by mini-css-extract-plugin
export default {"container":"_CooperVisionProductsStyles_container__gAZBj","products-button":"_CooperVisionProductsStyles_products-button__4dlYL"};